import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const QuoteOutline = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 49 49"
      fill="none"
      {...rest}
    >
      <g clipPath="url(#clip0_2008_8898)">
        <path
          d="M18.0645 6.88599H4.56445C2.08345 6.88599 0.0644531 8.90499 0.0644531 11.386V24.886C0.0644531 27.367 2.08345 29.386 4.56445 29.386H10.62L8.34295 41.0995C8.16895 41.9935 8.90695 42.886 9.81445 42.886H14.6745C15.9795 42.886 17.1375 42.0325 17.5335 40.7965L21.8985 30.439C21.924 30.379 21.945 30.319 21.963 30.259C22.362 28.8205 22.5645 27.334 22.5645 25.8415V11.386C22.5645 8.90499 20.5455 6.88599 18.0645 6.88599ZM19.5645 25.8415C19.5645 27.0325 19.407 28.2175 19.0965 29.3635L14.7375 39.706C14.7126 39.7646 14.6916 39.8247 14.6745 39.886H11.634L13.911 28.171C13.9502 27.9543 13.9418 27.7317 13.8862 27.5186C13.8306 27.3055 13.7293 27.1071 13.5892 26.9372C13.4491 26.7673 13.2737 26.6299 13.0751 26.5347C12.8766 26.4395 12.6596 26.3888 12.4395 26.386H4.56445C3.73795 26.386 3.06445 25.7125 3.06445 24.886V11.386C3.06445 10.5595 3.73795 9.88599 4.56445 9.88599H18.0645C18.891 9.88599 19.5645 10.5595 19.5645 11.386V25.8415ZM43.5645 6.88599H30.0645C27.5835 6.88599 25.5645 8.90499 25.5645 11.386V24.886C25.5645 27.367 27.5835 29.386 30.0645 29.386H36.12L33.843 41.101C33.6674 42.001 34.398 42.886 35.3145 42.886H40.1745C41.4795 42.886 42.639 42.0325 43.032 40.7965L47.4 30.439C47.424 30.379 47.445 30.319 47.463 30.2575C47.862 28.819 48.0645 27.3325 48.0645 25.8415V11.386C48.0645 8.90499 46.0455 6.88599 43.5645 6.88599ZM45.0645 25.8415C45.0645 27.031 44.907 28.2145 44.595 29.3635L40.236 39.7045C40.212 39.7645 40.1925 39.8245 40.176 39.886H37.134L39.411 28.171C39.45 27.9543 39.4413 27.7318 39.3856 27.5188C39.33 27.3059 39.2286 27.1076 39.0886 26.9377C38.9486 26.7679 38.7732 26.6305 38.5748 26.5352C38.3764 26.44 38.1596 26.389 37.9395 26.386H30.0645C29.2365 26.386 28.5645 25.7125 28.5645 24.886V11.386C28.5645 10.5595 29.2365 9.88599 30.0645 9.88599H43.5645C44.3925 9.88599 45.0645 10.5595 45.0645 11.386V25.8415Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2008_8898">
          <rect width="48" height="48" fill="white" transform="translate(0.0644531 0.885986)" />
        </clipPath>
      </defs>
    </svg>
  );
};

QuoteOutline.displayName = 'QuoteOutline';
